<template>
  <div>
    <TextLinkList
      v-for="(textLinkListProp, index) in textLinkListProps"
      v-bind="textLinkListProp"
      :key="index"
    />
  </div>
</template>
<script>
import TextLinkList from '../../components/molecules/text_link_lists/TextLinkList.vue'
export default {
  components: { TextLinkList },
  props: {
    textLinkListProps: {
      type: Array,
      required: true
    }
  }
}
</script>
